import { endOfDay, isAfter, isBefore, startOfDay, subMonths } from "date-fns/esm";
import { zonedTimeToUtc } from "date-fns-tz";

import { DateRange } from "ds/components/Datepicker/types";
import { AspectType } from "types/generated";

import { TimeFilter } from "../types";

// TODO: remove it once BE aligns types
const ASPECT_TYPE_MAP = {
  [AspectType.RunMinutes]: "run-minutes",
  [AspectType.WorkersCount]: "worker-count",
};

export const getCSVDownloadLink = (aspectType: AspectType, timeFilter: TimeFilter) => {
  const aspect = ASPECT_TYPE_MAP[aspectType];
  const since = timeFilter.startTime.toISOString().split("T")[0];
  const until = timeFilter.endTime.toISOString().split("T")[0];

  // eslint-disable-next-line @cspell/spellchecker
  return `/usageanalytics/csv?aspect=${aspect}&since=${since}&until=${until}`;
};

// How far back the rollup tables retain data, so also the floor the picker offers.
const MAX_MONTHS_BACK = 6;

export const getCSVDownloadMaxDate = () => endOfDay(new Date());

export const getCSVDownloadMinDate = () => startOfDay(subMonths(new Date(), MAX_MONTHS_BACK));

// minDate and maxDate only bound the calendar grid: the field's segments can still be
// arrowed past them, and the endpoint rejects a window wider than six months.
export const validateCSVDownloadRange = ({ start, end }: DateRange): string | undefined => {
  if (isBefore(start, getCSVDownloadMinDate())) {
    return `Start date cannot be more than ${MAX_MONTHS_BACK} months ago`;
  }

  if (isAfter(end, getCSVDownloadMaxDate())) {
    return "End date cannot be in the future";
  }

  if (isAfter(start, end)) {
    return "Start date must be before the end date";
  }

  return undefined;
};

// getCSVDownloadLink reads the UTC calendar day while the picker hands back local dates,
// so each bound's wall clock is reinterpreted as UTC to keep the days the user picked.
export const getCSVDownloadTimeFilter = ({ start, end }: DateRange): TimeFilter => ({
  startTime: zonedTimeToUtc(start, "UTC"),
  endTime: zonedTimeToUtc(end, "UTC"),
});
